import { Link, Outlet } from 'react-router-dom';
import { Bike } from 'lucide-react';
import { Button } from '~/components/ui/button';
import { ThemeToggle, UserMenu } from './app-shell';
import { useAuth } from '~/lib/auth';
import { useCompany } from '~/lib/queries';
import { homeRouteFor } from '~/lib/auth';

/** Coquille des pages publiques : accueil, tunnel de reservation, connexion. */
export function PublicLayout() {
  const { user } = useAuth();
  const { data: company } = useCompany();

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <a
        href="#contenu-principal"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      >
        Aller au contenu principal
      </a>

      <header className="bg-background/95 sticky top-0 z-20 border-b border-border backdrop-blur">
        <div className="mx-auto flex h-14 w-full max-w-6xl items-center gap-3 px-4">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <Bike className="size-5" aria-hidden />
            <span className="truncate">{company?.tradeName ?? "HomeCycl'Home"}</span>
          </Link>

          <div className="flex-1" />

          <Button asChild size="sm" className="hidden sm:inline-flex">
            <Link to="/reserver">Prendre rendez-vous</Link>
          </Button>

          {user ? (
            <Button asChild size="sm" variant="ghost" className="hidden sm:inline-flex">
              <Link to={homeRouteFor(user.role)}>Mon espace</Link>
            </Button>
          ) : null}

          <ThemeToggle />
          <UserMenu />
        </div>
      </header>

      <main id="contenu-principal" className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-border">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>
            {company?.legalName ?? 'LeCycleLyonnais SAS'}
            {company?.siret ? ` — SIRET ${company.siret}` : null}
          </p>
          <nav aria-label="Liens de pied de page" className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-foreground">
              Mentions legales
            </Link>
            <Link to="/donnees-personnelles" className="hover:text-foreground">
              Donnees personnelles
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
